import VueRouter from 'vue-router';

// Vue Templates
import Home from '../views/Home.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/:course',
        name: 'Course',
        // component: Course,
        // route level code-splitting
        // this generates a separate chunk for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "course" */ '../views/Course.vue'),
    },
];

const router = new VueRouter({
    routes,
    mode: 'history',
});

export default router;
